import { styled } from '@mui/material/styles';

const LogoImage = styled('img')({
  verticalAlign: 'middle',
  // explicit height gives viewBox-only SVGs (no intrinsic size) a box to scale to
  height: '40px',
  width: 'auto',
  maxWidth: '200px',
  objectFit: 'contain',
});

export default LogoImage;
